module.exports = __webpack_public_path__ + "images/b696638a71a48fed98ce9f1fe8a5dab3.png";